import { Query, QueryOrderDirection, QueryFilter, QueryOrder, QueryCondition } from "../../api/apiTypes";


export function getQueryFilters(query: Query<any>, member: string, condition: QueryCondition, value: any): Array<QueryFilter> {
    const values = value
        ? Array.isArray(value)
            ? value.length > 0
                ? value
                : null
            : [value]
        : null;

    const filters = query.Filters
        .filter((item) => !(item.Member === member
            && item.Condition === condition));

    if (values)
        filters.push({
            Member: member,
            Condition: condition,
            Values: values,
        });
    return filters;
}

export function getQuerySorting(query: Query<any>, member: string): QueryOrder {
    return {
        Member: member,
        Direction: query.Order && query.Order.Member === member
            && query.Order.Direction === QueryOrderDirection.Ascending
            ? QueryOrderDirection.Descending
            : QueryOrderDirection.Ascending,
    }
}
